import React from 'react';
import Button from '../../molecules/Button';
import { StyledResyncModalContent } from './LeadsDetails.styles';
import { IoCheckmarkCircleOutline } from 'react-icons/io5';

const ResyncModalContent = ({ leadsAdded, onClose, onCancel }) => {
  return (
    <StyledResyncModalContent>
      <div className="message-container">
        <div className="message-title">
          <IoCheckmarkCircleOutline size={24} color="#317bff" />
          Resync Confirmation
        </div>
        <p className="message-text">
          This list is currently used in a running campaign. Do you want to add the resynced leads to the campaign?
        </p>
      </div>
      <div className="button-group">
        <Button variant="outline" rounded onClick={onCancel}>
          No
        </Button>
        <Button variant="darkBlue" rounded onClick={onClose}>
          Yes
        </Button>
      </div>
    </StyledResyncModalContent>
  );
};

export default ResyncModalContent;
